export default "__VITE_ASSET__gcWW8Al9__"